import React from "react";
import "./NavBar.css";

export default function NavBar() {
  return (
    <nav id="nav_bar">
      <img
        style={{
          position: "relative",
          height: "1.6rem",
          width: "1.6rem",
          borderRadius: "100%",
          border: "1px solid white",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          backdropFilter: "blur(24px)",

          padding: "6px",
        }}
        src="/logo.svg"
      />
      <NavBarLinks></NavBarLinks>
    </nav>
  );
}

class NavBarLink extends React.Component {
  render() {
    return (
      <ul>
        <a href={this.props.href} className="navBarLinks">
          {this.props.name}
        </a>
      </ul>
    );
  }
}

function NavBarLinks() {
  return (
    <div name="NavBarLinks">
      <NavBarLink name="Contact Us" href="#Contact_Us_Header"></NavBarLink>
      <NavBarLink name="About us" href="#About_Us_Header"></NavBarLink>

      <NavBarLink name="Market Place" href="#Marketplace_Header"></NavBarLink>
      <NavBarLink name="Events" href="#Events_Header"></NavBarLink>
    </div>
  );
}
